import { requireNonNullable } from '@disy/lib/custom-error';

import type { DataAcquisitionModalWithGeometry } from 'cadenza/workbook/acquisition/data-acquisition-modal-with-geometry/data-acquisition-modal-with-geometry';

export function isDataAcquisitionModalWithGeometryOpen() {
  return Boolean(document.querySelector('.d-feature-acquisition-modal'));
}

export function getDataAcquisitionModalWithGeometry() {
  return requireNonNullable(document.querySelector<DataAcquisitionModalWithGeometry>('.d-feature-acquisition-modal'));
}
